export default function CessionsConfiguration($translatePartialLoaderProvider) {
	$translatePartialLoaderProvider.addPart('cessions');
}

CessionsConfiguration.$inject = ['$translatePartialLoaderProvider'];
